export class Validation {
    /**
     * @param {Object} component
     */
    constructor(component) {
        this._component = component;
    }

    ruleEmail(v, attr) {
        return /.+@.+\..+/.test(v) || 'The ' + attr + ' must be a valid email address.';
    }

    ruleRequired(v, attr) {
        return !!v || 'The ' + attr + ' field is required.';
    }

    rulePassword() {
        return [
            v => this.ruleRequired(v, 'Password'),
            v => this.ruleMin(v, 'string', 5, 'Password'),
        ];
    }

    rulePasswordConfirm() {
        return [
            v => this.ruleRequired(v, 'Password Confirmation'),
            v => v === this._component.form_data.password || 'The Password Confirmation does not match.'
        ];
    }

    ruleMin(v, type, min, attr) {
        return (v && v.length >= min) || 'The ' + attr + ' must be at least ' + min + ' characters.';
    }
}
